/**
 * Inspire-hub 2 (www.giap.pl)
 *
 * Copyright © GIAP sp.z.o.o. All rights reserved.
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Krzysztof Gregorowicz <gregorowicz.k@gmail.com>, February 2017
 */
/* eslint-disable max-len */
import _ from 'lodash';
import React, { PropTypes } from 'react';
import Nav from 'react-bootstrap/lib/Nav';
import NavItem from 'react-bootstrap/lib/NavItem';

import withStyles from 'isomorphic-style-loader/lib/withStyles';

import DataManagementView from './SettingsViews/DataManagementView';
import DistrictView from './SettingsViews/DistrictView';
import LayersView from './SettingsViews/LayersView/';
import StylesView from './SettingsViews/StylesView';
import UsersView from './SettingsViews/UsersView';
import MapsView from './SettingsViews/MapsView';
import InvestView from './SettingsViews/InvestView';
import CemenView from './SettingsViews/CemenView';

import s from './Settings.scss';

function adminOnly(roles) {
  const isAdmin = _.find(roles, o => o.nazwa === 'admin');
  if (isAdmin) {
    return true;
  }
  return false;
}

const viewsProps = [
  {
    viewName: 'Zarządzanie warstwami',
    viewDesc: 'Dodawanie, usuwanie, publikacja warstw.',
  },
  {
    viewName: 'Zarządzanie stylami',
    viewDesc: 'Dodawanie usuwanie oraz modyfikacja styli. ',
  },
  {
    viewName: 'Zarządzanie danymi',
    viewDesc: 'Dodawanie rekordów danych.',
  },
  {
    viewName: 'Zarządzanie użytkownikami',
    viewDesc: 'Zarządzanie użytkownikami',
  },
  {
    viewName: 'Zarządzanie gminą',
    viewDesc: 'Modyfikacja informacji o gminie.',
  },
  {
    viewName: 'Zarządzanie mapą',
    viewDesc: 'Modyfikacja informacji zawartej na mapie oraz minimapie.',
  },
  {
    viewName: 'Zarządzanie ofertami inwestycyjnymi',
    viewDesc: '',
  },
  {
    viewName: 'Zarządzanie cmentarzami',
    viewDesc: 'Zarządzanie danymi i zdjęciami cmentarzy',
  },
];

class Settings extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedKey: 0,
    };

    this.subViews = [];
    this.createSubViews();
  }

  createSubViews = () => {
    const LayerV = (
      <LayersView {...viewsProps[0]} user={this.props.user} district={this.props.district} />
    );
    this.subViews.push(LayerV);
    const StylV = (
      <StylesView {...viewsProps[1]} user={this.props.user} district={this.props.district} />
    );
    this.subViews.push(StylV);
    const DataV = (
      <DataManagementView
        {...viewsProps[2]}
        user={this.props.user}
        district={this.props.district}
      />
    );
    this.subViews.push(DataV);
    const UserV = (
      <UsersView {...viewsProps[3]} user={this.props.user} district={this.props.district} />
    );
    if (adminOnly(this.props.user.user.roles)) this.subViews.push(UserV);
    const MapsV = (
      <MapsView {...viewsProps[5]} user={this.props.user} district={this.props.district} />
    );
    this.subViews.push(MapsV);
    const DistrictV = (
      <DistrictView {...viewsProps[4]} user={this.props.user} district={this.props.district} />
    );
    this.subViews.push(DistrictV);

    const invest = (
      <InvestView {...viewsProps[6]} district={this.props.district} />
    );
    this.subViews.push(invest);

    const cemen = (
      <CemenView {...viewsProps[7]} district={this.props.district} />
    );
    this.subViews.push(cemen);
  };

  handleSelect = selectedKey => {
    this.setState({ selectedKey });
  };

  render() {
    return this.props.user ? (
      <div className="settingsModal">
        <div className="row">
          <div className="col-sm-12">
            <div className="settingsPanel">
              <div className="panel-heading">
                <Nav
                  bsStyle="pills"
                  activeKey={this.state.selectedKey}
                  onSelect={this.handleSelect}
                >
                  {this.subViews.map((v, i) => (
                    <NavItem key={i} eventKey={i}>
                      {v.props.viewName}
                    </NavItem>
                  ))}
                </Nav>
                <div className="closeIcon">
                  <i onClick={this.props.onCloseSettings} className="glyphicon glyphicon-remove" />
                </div>
              </div>
            </div>
            <div className="settingsBody">
              <div className="navbar navbar-default">
                <div className="container-fluid">
                  <div className="navbar-header">
                    <a className="navbar-brand">
                      {this.subViews[this.state.selectedKey].props.viewDesc}
                    </a>
                  </div>
                </div>
              </div>
              {this.subViews[this.state.selectedKey]}
            </div>
          </div>
        </div>
      </div>
    ) : null;
  }
}

export default withStyles(s)(Settings);



// WEBPACK FOOTER //
// src/components/Modals/Settings/Settings.js